export const SET_CURRENT_COUNTRY = 'SET_CURRENT_COUNTRY'

export const setCurrentCountry = (val: $TSFixMe) => ({
  type: SET_CURRENT_COUNTRY,
  val,
})
